export default "__VITE_ASSET__D2vH1000__"